<script lang="ts">
    import type {ICartItem, IStockITem} from "../../interfaces";
    import {getFormatter} from "../../utils";

    export let data: any;
    let formatter = getFormatter();

</script>
<div>
    <div class="grid-auto-1 gap-1 mb-1">
        <div style="width: 50px">
            {#if data.item.image}
                <img class="w-100" src="{data.item.image}">
            {:else}
                <img class="w-100" src="/static/storefront/pix/no_foto.jpg">
            {/if}
        </div>
        <div>
            <div class="box-b">
                <div>
                    <strong class="block" style="font-size: 14px">{data.item.name}</strong>
                    {#if data.item.reference}
                        <div style="font-size: 12px">{data.item.reference}</div>
                    {/if}
                    <p>Cantidad: {data.quantity}</p>
                    {#if data.flag}
                        <div class="discount mt-ii">{data.flag}</div>
                    {/if}
                </div>

                <div class="text-r">
                    {#if data.previousPrice}
                        <small>Antes {formatter(data.previousPrice)}</small>
                    {/if}
                    <div class="price">{formatter(data.price)}</div>
                </div>

            </div>


        </div>
    </div>
</div>
<style>
    .discount {
        background: black;
        color: white;
        font-size: 12px;
        font-weight: bold;
        width: max-content;
        padding: 5px;
    }
</style>